import(/* webpackMode: "eager" */ "/home/runner/work/Okkanti/Okkanti/src/app/privacy/page.tsx");
